import type { ThemeConfig } from 'antd';

export const PAYEASE_PRIMARY_COLOR = '#f26522';

export const PAYEASE_THEME: ThemeConfig = {
  token: {
    colorPrimary: PAYEASE_PRIMARY_COLOR,
    colorInfo: PAYEASE_PRIMARY_COLOR,
    colorLink: PAYEASE_PRIMARY_COLOR,
    borderRadius: 8,
    fontFamily: "'Work Sans', system-ui, sans-serif",
    colorText: '#231f20',
    colorBorder: '#dedede',
    colorBgMask: 'rgba(0, 0, 0, 0.7)',
  },
};
